export enum UserSetLootsActionTypes {
  OPEN_REQUEST = 'user-set-loots/OPEN_REQUEST',
  OPEN_SUCCESS = 'user-set-loots/OPEN_SUCCESS',
  OPEN_ERROR = 'user-set-loots/OPEN_ERROR',
}
